<template>
  <form @submit.prevent="evOnSubmit">
    <b-row>
      <b-col>
        <label-required-field label="Lote" />
        <b-input type="text" v-model="lot" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label-required-field label="Data de entrada" />
        <b-input disabled type="date" v-model="entry_date" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label-required-field label="Data de vencimento" />
        <b-input
          :type="objLot.type == 'MEDICINE' ? 'month' : 'date'"
          v-model="due_date"
        />
      </b-col>
    </b-row>
    <warning-required-fields />
    <errors-messages :errors="errors" />
    <div class="row">
      <div class="col-md-12 text-right pt-0 pb-0">
        <v-btn :disabled="loading" type="submit" class="btn-save ml-2">
          <i class="fas fa-save mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </form>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import LabelRequiredField from "../../../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../../../Components/WarningRequiredFields.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";
import moment from "moment";

export default {
  name: "ViewLot",

  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },

  props: {
    objLot: [Object, null],
  },

  data() {
    return {
      errors: [],
      loading: false,
      lot: "",
      entry_date: "",
      due_date: "",
    };
  },

  created() {
    this.errors = [];

    let { lot, entry_date, due_date, type } = this.objLot;

    this.lot = lot;
    this.entry_date = moment(entry_date).format("YYYY-MM-DD");
    if (type == "MEDICINE") {
      if (due_date) {
        this.due_date = moment(due_date).format("YYYY-MM");
      }
    } else {
      if (due_date) {
        this.due_date = moment(due_date).format("YYYY-MM-DD");
      }
    }
  },

  methods: {
    async evOnSubmit() {
      try {
        this.loading = true;

        let { objLot, lot, due_date, entry_date } = this;

        const data = {
          id: objLot.id,
          lot,
          due_date,
          entry_date,
        };

        const response = await api.patch("/rest-home/stock/items/lot", data);

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide(`view_lot-${objLot.id}`);
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>